import React, { useEffect, useRef, useState } from 'react';
import { FiCheck, FiChevronDown } from 'react-icons/fi';

const BoardSelect = function({boards, boardId, onChange}) {
  const [open, setOpen] = useState(false);

  const rootRef = useRef(null);
  const triggerRef = useRef(null);
  const listRef = useRef(null);
  const active = boards.find(board => board.id === boardId);

  useEffect(() => {
    const close = function(event) {
      if (!rootRef.current?.contains(event.target)) setOpen(false);
    };

    document.addEventListener('pointerdown', close);

    return () => document.removeEventListener('pointerdown', close);
  }, []);

  useEffect(() => {
    if (open) listRef.current?.querySelector('[aria-selected="true"]')?.focus();
  }, [open]);

  const navigate = function(event) {
    const options = [...listRef.current.querySelectorAll('[role="option"]')];
    const index = options.indexOf(document.activeElement);

    let next;

    if (event.key === 'ArrowDown') next = (index + 1) % options.length;
    if (event.key === 'ArrowUp') next = (index - 1 + options.length) % options.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = options.length - 1;
    if (event.key === 'Tab') setOpen(false);

    if (event.key === 'Escape') {
      event.preventDefault();
      setOpen(false);
      triggerRef.current.focus();
    }

    if (next !== undefined) {
      event.preventDefault();
      options[next].focus();
    }

    event.stopPropagation();
  };

  return <div
    className='boardSelector'
    ref={rootRef}
    onBlur={event => {
      if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
    }}
  >
      <button
        ref={triggerRef}
        className='boardSelect h'
        aria-label={`select board: ${active?.name || 'untitled board'}`}
        aria-haspopup='listbox'
        aria-expanded={open}
        onClick={() => setOpen(value => !value)}
        onKeyDown={event => {
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            event.stopPropagation();
            setOpen(true);
          }
        }}
      >
        <span>{active?.name || 'untitled board'}</span><FiChevronDown size={14} aria-hidden='true' />
      </button>
      {open && <div
        className='boardOptions'
        ref={listRef}
        role='listbox'
        aria-label='boards'
        onKeyDown={navigate}
      >
        {boards.map(board => <button
          key={board.id}
          role='option'
          aria-selected={board.id === boardId}
          className='boardOption h'
          onClick={() => {
            setOpen(false);
            triggerRef.current.focus();
            onChange(board.id);
          }}
        >
          <span>{board.name || 'untitled board'}</span>{board.id === boardId && <FiCheck size={14} aria-hidden='true' />}
        </button>)}
      </div>}
    </div>;
};

export default BoardSelect;
